import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-2xl mt-8 mb-8">
      <h1 className="text-3xl font-bold mb-6">Общи условия на онлайн магазин TC Energy</h1>

      <p className="mb-4">
        Тези Общи условия уреждат отношенията между TC Energy (наричан по-долу „Продавач“) и клиентите на онлайн магазина на адрес{" "}
        <a href="https://tcenergy.bg" className="text-blue-600 underline">https://tcenergy.bg</a> (наричани по-долу „Клиенти“ или „Потребители“). С всяка поръчка клиентът приема тези условия.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">1. Данни за търговеца</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Наименование: TC Energy ЕООД</li>
        <li>ЕИК: [въведете вашия ЕИК]</li>
        <li>Адрес на управление: [въведете адрес]</li>
        <li>Имейл: [въведете имейл]</li>
        <li>Телефон: [въведете телефон]</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">2. Обект на договора</h2>
      <p className="mb-4">
        Онлайн магазинът предлага за продажба препарати за дома, градината, битови и промишлени нужди.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">3. Сключване на договор</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Поръчката се счита за направена при натискане на бутона „Поръчай“ и потвърждение на поръчката.</li>
        <li>Договорът се сключва с потвърждение от страна на Продавача чрез имейл или телефон.</li>
        <li>Клиентът се задължава да предоставя коректни и точни данни за доставка и контакт.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">4. Цени и плащане</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Цените са в BGN с включено ДДС.</li>
        <li>Продавачът запазва правото да променя цените, валидни само за нови поръчки.</li>
        <li>Методи на плащане: Онлайн карта, Наложен платеж, Банков превод.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">5. Доставка</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Доставката се извършва до посочен от клиента адрес чрез куриер.</li>
        <li>Срок за доставка: до 5 работни дни.</li>
        <li>Клиентът носи отговорност за правилно въведен адрес.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">6. Право на отказ и връщане</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Клиентът има право на отказ без причина в срок от 14 дни.</li>
        <li>Формулярът за отказ се изпраща на имейл: [въведете имейл]</li>
        <li>Продуктите трябва да са в оригиналната опаковка и неизползвани.</li>
        <li>Разходите за връщане се поемат от клиента, освен при дефектен или грешен продукт.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">7. Рекламации и гаранции</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Гаранция за съответствие със спецификациите на производителя.</li>
        <li>Рекламации се подават на [имейл за рекламации] с документ за покупка.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">8. Лични данни и поверителност</h2>
      <p className="mb-4">
        Данните се обработват според Закона за защита на личните данни и не се предоставят на трети лица, освен на куриерски услуги.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">9. Интелектуална собственост</h2>
      <p className="mb-4">Всички текстове, изображения и лога са собственост на TC Energy.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-3">10. Отговорности</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Продавачът не носи отговорност за неправилна употреба на продукта или забавяне по куриер.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-3">11. Спорове и приложимо право</h2>
      <ul className="list-disc list-inside mb-4">
        <li>Споровете се уреждат чрез преговори или компетентен български съд.</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
